import { render, staticRenderFns } from "./LayoutRegion.vue?vue&type=template&id=62353ab0"
import script from "./LayoutRegion.vue?vue&type=script&lang=js"
export * from "./LayoutRegion.vue?vue&type=script&lang=js"
import style0 from "./LayoutRegion.vue?vue&type=style&index=0&id=62353ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports